import { Typography } from '@mui/material';
import React from 'react';
import { Placement } from 'react-joyride';

export const GuidedSteps = [
  {
    title: 'GPT 6.1 is here!',
    target: '#llm-select',
    disableBeacon: true,
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Typography style={{ textAlign: 'start' }}>
          GPT 6.1 is here and enabled by default for everyone.
        </Typography>
        <ul style={{ display: 'flex', flexDirection: 'column' }}>
          <li style={{ textAlign: 'start' }}>Better reasoning and more accurate responses</li>
          <li style={{ textAlign: 'start' }}>Responses now appear as they are written</li>
          <li style={{ textAlign: 'start' }}>Switch back to GPT 5.1 here at any time</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Prompt Filters',
    target: '#filter-container',
    placement: 'right' as Placement,
    content: (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Typography style={{ textAlign: 'start' }}>
          Use the filters to narrow down the prompt library by tag.
        </Typography>
      </div>
    ),
  },
];
